import { User } from "@edl-development/edl-common";

export class UserHelper {        

    public static isParaeducator(user: User) {
        return this.hasRole(user, 'Paraeducator');
    }

    public static isEmergencyCert(user: User) {
        return this.hasRole(user, 'Emergency_Cert');
    }

    private static hasRole(user: User, roleName: string) {
        return !!user.UserRoles &&
            user.UserRoles.map(userRole => userRole.RoleName).indexOf(roleName) !== -1;
    }
}